<!-- CONTAINER -->
<div class="container content-area relative">
    <!-- ROW-1 OPEN -->
    <form [formGroup]="formGroup" (submit)="submit()">
        <div class="row">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Add Guidance Category</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label for="categoryname">Name</label>
                                    <input type="text" class="form-control" form placeholder="Guidance Category Name"
                                        formControlName="name">
                                    <small
                                        *ngIf="f.name.invalid && (f.name.dirty || f.name.touched)"
                                        class="d-block alert alert-danger mt-1">
                                        Required
                                    </small>
                                </div>
                            </div>
                           
                        </div>
                        <div class="row">                            
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label for="category_image">Image</label>
                                    <input type="file" class="form-control" id="category_image"
                                        placeholder="Guidance Category Image" #fileInput (change)="uploadImage($event)">
                                  
                                </div>
                            </div>
                           
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-success mt-1" [disabled]="!formGroup.valid">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <!-- ROW-1 CLOSED -->


</div>
<!--CONTAINER CLOSED -->